export default {
  metadata: {
    version: '1.0.0',
    id: 'selector-1.0.0',
    name: 'JDSSelector',
    description:
      'A selector is a control that allows the user choose a value from a range of options.'
  },
  hierarchy: {
    container: [
      {
        'selector-container': ['jds_selector_item']
      },
      {
        'outer-container': ['inner-container']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{s_0}'
    },
    'selector-container': {
      opacity: '{s_1}',
      'align-items': '{s_2}',
      'justify-content': '{s_3}',
      'border-radius': '{s_4}',
      'padding-top': '{s_5}',
      'padding-right': '{s_6}',
      'padding-bottom': '{s_7}',
      'padding-left': '{s_8}',
      gap: '{s_15}',
      'flex-direction': '{s_16}'
    },
    jds_selector_item: {
      wrap: 'horizontal',
      kind: 'label_icon'
    },
    'outer-container': {
      'z-index': -1,
      'justify-content': '{s_19}',
      'background-color': '{s_13}',
      'border-radius': '{s_4}',
      'align-items': '{s_20}',
      'padding-top': '{s_9}',
      'padding-right': '{s_10}',
      'padding-bottom': '{s_11}',
      'padding-left': '{s_12}',
      width: '{s_17}',
      height: '{s_18}',
      disabled: true,
      transition: {
        property: ['padding-left'],
        duration: '{rapid}',
        'timing-function': '{easeJoyful}'
      }
    },
    'inner-container': {
      'background-color': '{s_21}',
      'border-radius': '{s_22}',
      show: true,
      transition: {
        property: ['width'],
        duration: '{rapid}',
        'timing-function': '{easeJoyful}'
      }
    }
  },
  variant: {
    stretch: {
      true: {
        container: {
          width: '{s_23}'
        },
        'selector-container': {
          width: '{s_24}'
        },
        jds_selector_item: {
          flex: 1,
          stretch: true
        }
      }
    },
    wrap: {
      vertical: {
        jds_selector_item: {
          wrap: 'vertical'
        }
      }
    },
    kind: {
      label: {
        jds_selector_item: {
          kind: 'label'
        }
      },
      icon: {
        jds_selector_item: {
          kind: 'icon'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      stretch: {
        values: [false, true],
        doc_description:
          'It can be used to fill the container in which Selector is present.'
      },
      kind: {
        type: 'JDSSelectorItem.kind',
        values: ['label_icon', 'label', 'icon']
      },
      wrap: {
        type: 'JDSSelectorItem.wrap',
        values: ['horizontal', 'vertical']
      }
    },
    data: {
      'selector-container': {
        value: {
          type: 'list',
          name: 'items',
          object: {
            value: 'string',
            label: 'string',
            id: 'string',
            icon: 'icon',
            disabled: 'boolean'
          }
        }
      },
      jds_selector_item: {
        selectedIndex: {
          type: 'number',
          name: 'selectedIndex',
          doc_description:
            'It gives the current index of selected button of Selector. User can overwrite it by passing a new value.'
        },
        value: {
          type: 'string',
          name: 'items.value'
        },
        label: {
          type: 'string',
          name: 'items.label'
        },
        id: {
          type: 'string',
          name: 'items.id'
        },
        icon: {
          type: 'icon',
          name: 'items.icon'
        },
        disabled: {
          type: 'boolean',
          name: 'items.disabled'
        }
      },
      'outer-container': {
        'padding-left': {
          type: 'size',
          name: '_left'
        }
      },
      'inner-container': {
        width: {
          type: 'size',
          name: '_width'
        },
        height: {
          type: 'size',
          name: '_height'
        }
      }
    },
    events: {
      jds_selector_item: {
        onAppear: {
          name: '_onAppear',
          platform: 'ios, android'
        },
        onClick: 'onClick'
      },
      container: {
        onAppear: {
          name: '_onSelectorAppear',
          platform: 'ios'
        }
      }
    },
    a11y: {
      'selector-container': {
        name: 'items',
        properties: {
          role: {
            value: 'radiogroup'
          }
        },
        repeating: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          iconAriaLabel: 'iconAriaLabel'
        }
      },
      jds_selector_item: {
        properties: {
          ariaLabel: 'items.ariaLabel',
          ariaDescribedby: 'items.ariaDescribedby',
          iconAriaLabel: 'items.iconAriaLabel'
        }
      }
    }
  }
};
